import * as action_types from "../actions/action_types";

const initialState = {
  top_header: [],
  selected_language: 1,
  transilations: [],
  loading: false,
};
const changeLanguage = (state, language) => {
  return {
    ...state,
    selected_language: language
  };
};
const setLoading = state => {
  return {
    ...state,
    loading: true
  };
};
const finishLoading = state => {
  return {
    ...state,
    loading: false
  };
};
const reducer = (state = initialState, action) => {
  switch (action.type) {
    case action_types.LANGUAGE_CHANGED:
      return changeLanguage(state, action.language);
    case action_types.CHANGE_LANGUAGE_STARTED:
      return setLoading(state);
    case action_types.CHANGE_LANGUAGE_END:
      return finishLoading(state);
    default:
      return state;
  }
};

export default reducer;
